import { useSearchParams } from "react-router-dom";

export default function useCommentParams() {
  const [search, setSearch] = useSearchParams();

  const openComments = (startingTab?: string) => {
    search.delete("brie");
    search.delete("comments");
    search.delete("record-chat");
    search.delete("private");

    if (startingTab === "BrieGPT") {
      search.set("brie", "true");
    } else {
      search.set("comments", "true");
    }

    setSearch(search, { replace: true });
  };

  const closeComments = () => {
    search.delete("comments");
    search.delete("brie");
    search.delete("record-chat");
    search.delete("private");
    setSearch(search, { replace: true });
  };

  return {
    open: !!search.get("comments"),
    websiteOpen: !!search.get("w"),
    openComments,
    closeComments,
  };
}
